(() => {
  const media = matchMedia('(max-width:1100px)');
  function initialise(root) {
    if (!root || root.dataset.lmReady) return;
    root.dataset.lmReady = 'true';
    root.querySelectorAll('form.lm-localization').forEach(form => {
      form.addEventListener('change', event => {
        if (!event.target.matches('select[name="locale_code"], select[name="language_code"], select[name="country_code"]')) return;
        const returnTo = form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
        HTMLFormElement.prototype.submit.call(form);
      });
    });
    const order = ['kjoretoy', 'tilhengere', 'deler-tilbehor', 'utstyr', 'mc-utstyr', 'outlet', 'vannsport-brygge', 'utleie', 'service-tjenester'];
    function arrange(container) {
      if (!container) return;
      const rank = element => {
        const key = element.dataset.lmMenu || element.dataset.lmMobileMenu || (element.classList.contains('lm-outlet') ? 'outlet' : '');
        const index = order.indexOf(key);
        return index < 0 ? order.length : index;
      };
      [...container.children].sort((a, b) => rank(a) - rank(b)).forEach(element => container.append(element));
    }
    arrange(root.querySelector('.lm-nav-links'));
    arrange(root.querySelector('[data-lm-mobile-root]'));
    const menus = [...root.querySelectorAll('[data-lm-menu]')];
    const shade = root.querySelector('[data-lm-shade]');
    const opener = root.querySelector('[data-lm-open]');
    const dialog = root.querySelector('[data-lm-dialog]');
    const back = root.querySelector('[data-lm-back]');
    const title = root.querySelector('[data-lm-title]');
    const rootList = root.querySelector('[data-lm-mobile-root]');
    const panels = [...root.querySelectorAll('[data-lm-mobile-panel]')];
    const browseTitle = title.textContent;
    const search = root.querySelector('.lm-search input');
    const desktopPlaceholder = search.placeholder;
    function searchHint() {
      search.placeholder = media.matches ? search.dataset.lmMobilePlaceholder : desktopPlaceholder;
    }
    searchHint();
    let lastTrigger = null;
    function closeDesktop(focus = false) {
      menus.forEach(menu => {
        menu.open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      });
      shade.hidden = true;
      if (focus && lastTrigger) lastTrigger.focus();
    }
    function mobileRoot(focus = false) {
      panels.forEach(panel => { panel.hidden = true; });
      rootList.hidden = false;
      back.hidden = true;
      title.textContent = browseTitle;
      dialog.scrollTop = 0;
      if (focus && lastTrigger) lastTrigger.focus();
    }
    function mobileTop() {
      root.style.setProperty('--lm-mobile-header-bottom', Math.max(0, root.querySelector('.lm-header').getBoundingClientRect().bottom) + 'px');
    }
    function closeMobile() {
      if (dialog.open) dialog.close();
    }
    menus.forEach(menu => {
      const summary = menu.querySelector('summary');
      summary.addEventListener('click', event => {
        event.preventDefault();
        const shouldOpen = !menu.open;
        closeDesktop();
        if (shouldOpen) {
          lastTrigger = summary;
          menu.open = true;
          summary.setAttribute('aria-expanded', 'true');
          shade.hidden = false;
        }
      });
    });
    shade.addEventListener('click', () => closeDesktop(true));
    opener.addEventListener('click', () => {
      closeDesktop();
      mobileRoot();
      mobileTop();
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lm-menu-open');
      dialog.querySelector('[data-lm-close]').focus();
    });
    root.querySelector('[data-lm-close]').addEventListener('click', closeMobile);
    back.addEventListener('click', () => mobileRoot(true));
    root.querySelectorAll('[data-lm-mobile-menu]').forEach(button => {
      button.addEventListener('click', () => {
        const panel = panels.find(p => p.dataset.lmMobilePanel === button.dataset.lmMobileMenu);
        if (!panel) return;
        lastTrigger = button;
        rootList.hidden = true;
        panels.forEach(p => { p.hidden = p !== panel; });
        back.hidden = false;
        title.textContent = button.dataset.lmLabel;
        dialog.scrollTop = 0;
        back.focus();
      });
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('lm-menu-open');
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) closeMobile();
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !dialog.open) {
        event.preventDefault();
        event.stopPropagation();
        closeDesktop(true);
      }
      if (event.key === '/' && !dialog.open && !['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)) {
        event.preventDefault();
        closeDesktop();
        search.focus();
      }
    });
    root.querySelectorAll('a.js-drawer-open-cart').forEach(link => link.addEventListener('click', () => {
      closeDesktop();
      closeMobile();
    }));
    media.addEventListener('change', () => {
      searchHint();
      closeDesktop();
      closeMobile();
      mobileTop();
    });
    window.addEventListener('resize', () => { if (dialog.open) mobileTop(); });
    function countCart(event) {
      const cart = event.detail && (event.detail.cart || event.detail);
      if (cart && typeof cart.item_count === 'number') {
        root.querySelectorAll('[data-lm-cart-count]').forEach(count => {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        });
      }
    }
    document.addEventListener('cart:updated', countCart);
    document.addEventListener('cart:change', countCart);
  }
  function start(parent = document) {
    parent.querySelectorAll('[data-lm-navigation]').forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-lm-dialog][open]')) document.body.classList.remove('lm-menu-open');
  });
})();
